
import { mapState, mapMutations } from "vuex";
import { isMobile } from "../../util";

export default {
	name: 'StickyBet',

	components: {
	},

	filters: {

	},


	data() {
		return {
			isShow: isMobile() ? true : false
		};
	},

	watch: {
	},
	computed: {
		...mapState(["user"]),

	},
	created() {
	},


	beforeDestroy() {
	},

	methods: {
		...mapMutations([
		]),
		toggle() {
			this.isShow = !this.isShow
		}
	}
}
